export default __webpack_public_path__ + "static/media/poocoin512.8a6f28c7.png";